// extracted by mini-css-extract-plugin
export var card = "card-image-module--card--e581f";
export var cardContent = "card-image-module--cardContent--5bf2e";
export var date = "card-image-module--date--92890";
export var image = "card-image-module--image--1ff47";
export var title = "card-image-module--title--81a65";